import { useState } from "react";
import BcMenu from "../../components/Bc-menu/Bc-menu";
import { LayoutProps } from "../../interface/props/layout";
import BcHeader from "../../components/Bc-header/BcHeader";
import BcTitleHeader from "../../components/Bc-TitleHeader/Bc-TitleHeader";
import { BcMain } from "../../styled/global.styled";
import { Role } from "../../../constants/roles";
import { ProtectedRoute } from "../ProtectedRouter/ProtectedRouter";
import { BcBackground } from "src/shared/components/Bc-Background/Bc-background";
const LayoutMain = ({
  idPage,
  children,
  titlePage,
  requiredRoles,
  className,
}: LayoutProps) => {
  const [openMenu, setOpenMenu] = useState<boolean>(false);

  const showMenu = () => {
    setOpenMenu(!openMenu);
    console.log(openMenu);
  };

  return (
    <ProtectedRoute requiredRoles={requiredRoles}>
      <BcHeader onPress={showMenu} />
      <BcMenu activeMenu={openMenu}>
        {titlePage && <BcTitleHeader title={idPage} />}
        <BcMain id={idPage} title={titlePage ? "title" : ""} className={className}>
          {children}
          <BcBackground />
        </BcMain>
      </BcMenu>
    </ProtectedRoute>
  );
};

export default LayoutMain;

LayoutMain.defaultProps = {
  requiredRoles: [Role.AZURE],
};
